// SimTaskStream: 시뮬레이터 타입 무관 태스크 스트림 릴레이 (BFF → 웹).
//
// 어댑터가 공용 계약(vsmr.stream.v1, stream/sim_stream.proto)으로 Kafka에
// 발행한 것을 sim-stream-demux가 redis로 릴레이하고, BFF가 이 서비스로 웹에
// 중계한다. 태스크 타입 고유 스트림(MARS MinorEdit)의 단건 RPC는
// mars_task_stream에 있고, 탭 단위 멀티플렉스(SubscribeSessionStream)는 이를
// 포함한 태스크 스트림 전부와 세션 이벤트를 봉투(kind)로 나른다.
//
// 브라우저는 SubscribeSessionStream(탭당 연결 1개)만 쓴다 — 브라우저 HTTP/1.1은
// origin당 동시 연결 6개 한도라, 태스크별×종류별 개별 스트림은 참가자 수에
// 비례해 한도를 넘는다(스트림 요청이 preflight 후 브라우저 큐에서 기아).
// 단건 RPC(SubscribeSimState 등)는 헤드리스 클라이언트·진단용으로 유지한다.

// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file stream/sim_task_stream.proto (package vsmr.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetRecentSimFramesRequest, RecentSimFrames, SimStreamEnvelope, SubscribeSessionStreamRequest } from "./sim_task_stream_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { TaskId } from "../sm/simulation_manager_pb.js";
import { SimState } from "./sim_stream_pb.js";

/**
 * @generated from service vsmr.stream.v1.SimTaskStream
 */
export const SimTaskStream = {
  typeName: "vsmr.stream.v1.SimTaskStream",
  methods: {
    /**
     * 탭 단위 통합 멀티플렉스: 세션 이벤트·태스크 프레임을
     * 봉투 하나로 합쳐 **탭당 상시 연결 1개**로 릴레이한다. 이 스트림이 곧
     * 세션 liveness다 — BFF가 수립 시 SM AttachSession을 대신 쥐고, 절단 시
     * 놓는다(기존 detach 의미론). 구독 변경 = 원하는 전체 집합+재개 커서로
     * 재수립(선수립-후해제; 요청이 곧 진실이라 서버는 무상태). 세션은
     * x-session-id 메타데이터로 지정한다.
     *
     * 순서 보장: 같은 kind 안에서는 소스 순서 보존. kind 사이에는 **무보장** —
     * 서버는 제어 kind(SESSION_EVENT)를 데이터 프레임보다 우선 송신한다.
     * 상태 라벨은 이 스트림이 나르지 않는다: 자기가 일으킨 전이는 제어 응답으로,
     * 나머지는 세션 이벤트(TaskEnded·TaskStateChanged)로 확정한다.
     *
     * @generated from rpc vsmr.stream.v1.SimTaskStream.SubscribeSessionStream
     */
    subscribeSessionStream: {
      name: "SubscribeSessionStream",
      I: SubscribeSessionStreamRequest,
      O: SimStreamEnvelope,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Streams periodic simulation-state snapshots (progress, speed, status)
     * for the given task_id. 브라우저 정본은 SubscribeSessionStream 이고, 이
     * 단건 구독은 헤드리스 클라이언트(동시성 시험 도구)가 쓴다 — 실시간성
     * 측정(actual_speed)과 종결 판정의 소스다.
     *
     * @generated from rpc vsmr.stream.v1.SimTaskStream.SubscribeSimState
     */
    subscribeSimState: {
      name: "SubscribeSimState",
      I: TaskId,
      O: SimState,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * 최근 구간 조회 — 유한 질의이지 구독이 아니다. 이어보기처럼 "복귀 직전
     * 잠깐"의 문맥이 필요한 화면이 쓴다. 구독(Subscribe*)은 그 시점 이후만
     * 나르므로, 되감기 의미를 그쪽 계약에 얹지 않는다.
     *
     * 출처는 라이브 버퍼(redis)다. 장기 이력은 분석 저장소(Analysis
     * GetTelemetryRange)가 담당하는데, 그쪽은 sink를 한 단계 더 거쳐 가장
     * 최신 구간이 늦다 — "최근 N초"는 라이브 버퍼에 묻는 것이 맞다.
     *
     * @generated from rpc vsmr.stream.v1.SimTaskStream.GetRecentSimFrames
     */
    getRecentSimFrames: {
      name: "GetRecentSimFrames",
      I: GetRecentSimFramesRequest,
      O: RecentSimFrames,
      kind: MethodKind.Unary,
    },
  }
} as const;

